<template>
  <div class="list-count-result">
    <button
        class="style-label-underscore clear-filters-desktop"
        @click="$emit('clear-filters')"
    >
      Ryd filtre
    </button>
  </div>
</template>

<script setup>
const emit = defineEmits(['clear-filters'])
</script>
